<div class="table-layout" style="height: 4rem;">
    <div class="table-operation">
        <n-button-group [relateTable]="dt" [items]="[createBtn, deleteBtn]">
        </n-button-group>
    </div>
    <div class="table-container">
        <n-data-table #dt id="front-table-quota-table" [config]="tableConfig" [columnDefs]="tableColumnDefs"
        [data]="tableData" [(selection)]="selection">
        </n-data-table>
    </div>
</div>